import React, { useEffect, useState } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import Button from '../../../component/ui/Button';
import './Product.scss';
import sortbydot from '../../../assets/image/sort_by_group.svg';
import { useDispatch, useSelector } from 'react-redux';
import { change_status } from '../../../store/action/product';
import { toast } from 'react-toastify';
import { group_update, product_group_list } from '../../../store/action/group';
import Modal from '../../../component/modal/Modal';
import AddToGroupModal from './AddToGroupModal';
import { ObjectCreate } from '../../../utils/utility';
import InputField from '../../../component/form/FormInput';
import { status_dropdown } from '../../../utils/dropsdown';
import InputSelect from '../../../component/inputSelect/InputSelect';
import { formatErrors, hasPermission } from '../../../utils/controller';
import { ExportTable } from '../../../store/action/export/Export';
import BulkImport from './BulkImport';
import Pagination from '../../../component/pagination';
import arrowDownBlackIcon from '../../../assets/image/arrow_down_dark.svg';
import ImageRenderer from '../../../component/imageRenderer/imageRnder';
import { IoIosArrowRoundDown, IoIosArrowRoundUp } from 'react-icons/io';
import AdvanceFilter from '../../../component/Filter/AdvanceFilter';
import advanceFilterOptions from '../../../component/Filter/advanceFilterOptions';
import clearAllFilter from '../../../assets/image/clearAllFilter.svg';
import addFilter from '../../../assets/image/AddFilter.svg';
import advanceFilterIcon from '../../../assets/image/advanceFilter_white.svg';
import {
	clearAdvanceFilter,
	removeSelectedInput,
	setAdvanceFilter,
	setAdvanceFilterPage,
	setAdvanceFilterTotalPage,
	setSelectedInput,
	setSelectedInputData,
	setSelectedInputValue,
} from '../../../store/action/advanceFilter';
import AdvanceFilterSelectInput from '../../../component/Filter/AdvanceFilterSelectInput';
import { getFiltersParams } from '../../../helper';
import Table from '../../../component/table/Table';
import { getProductList, getProducts } from '../../../services/products';
import {
	checkProductStatus,
	colorFormatTag,
	formatTag,
	productStatusList,
} from '../../../utils/constant';
import TagHover from './components/tagHover';
import ProductMasterModel from './components/productMasterModel';
import ProductGroupModel from './components/productGroupModel';
import DataNotFound from '../../components/dataNotFound';
import { Plus } from 'lucide-react';

const Product = () => {
	const param = useParams();
	const [searchParams] = useSearchParams();
	const productId = param?.id;
	const GroupID = param?.id;
	const navigateRouter = (path) => {
		navigate(path);
	};
	const [currentPage, setCurrentPage] = useState(1);
	const [totalPages, setTotalPages] = useState(0);
	const [bulkAction, setBulkAction] = useState([]);
	const [open, setIsOpen] = useState(false);
	const [buklImport, setIsbuklImport] = useState(false);
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const [tableData, setTableData] = useState([]);
	const [groupOption, setGroupOptions] = useState([]);
	const [stateCondition, setStateCondition] = useState('');
	const [groupName, setgroupName] = useState('');
	const [groupStatus, setgroupStatus] = useState('');
	const [error, setError] = useState({});
	const [headerDropDown, setHeaderDropDown] = useState('All Products');
	const [sortParam, setSortParam] = useState('');
	const [showOptions, setShowOptions] = useState('');
	const [sortDirection, setSortDirection] = useState({});
	const [productList, setProductList] = useState([]);
	const [loading, setLoader] = useState(false);
	const [isAdvanceFilterOpen, setIsAdvanceFilterOpen] = useState(false);
	const [isProductMasterOpen, setIsProductMasterOpen] = useState(false);
	const productgroupData = useSelector((state) => state?.productGroup?.data?.data?.productGroups);
	const user = useSelector((state) => state?.userInfo?.userInfo?.data);
	const suburl = localStorage.getItem('suburl');
	const [deselectRows, setDeselectRows] = useState(null);
	const [params, setParams] = useState({
		page: 1,
		pageSize: 20,
		filters: {},
		orderBy: '',
		sortBy: '',
	});
	const {
		page: advanceFilterPage,
		totalPages: advanceFilterTotalPages,
		pageSize: advanceFilterPageSize,
		orderBy: advanceFilterOrderby,
		sortBy: advanceFilterSortBy,
		selectedInputs,
		isAdvanceFilterApplied,
	} = useSelector((state) => state.advanceFilter);

	const handleDeselectAll = (deselectAllRowsFn) => {
		setDeselectRows(() => deselectAllRowsFn);
	};

	const sortIconMap = {
		asc: <IoIosArrowRoundUp />,
		desc: <IoIosArrowRoundDown />,
	};

	const ProductTableColumn = [
		{
			field: ' ',
			headerClass: 'HeaderBg',
			checkboxSelection: true,
			headerCheckboxSelection: true,
			minWidth: 50,
			maxWidth: 50,
			lockPosition: true,
		},
		{
			field: 'IMAGE',
			headerClass: 'HeaderBg image-cell',
			cellClass: 'image-cell',
			suppressSizeToFit: true,
			minWidth: 77,
			maxWidth: 80,
			flex: 1,
			cellRenderer: ImageRenderer,
		},

		{
			field: 'PRODUCT CODE',
			headerClass: 'HeaderBg',
			suppressSizeToFit: true,
			minWidth: 150,
			flex: 1,
			cellRenderer: (params) => {
				const data = JSON.parse(params.data['product_code']);
				let tags = data.tags || [];

				let firstTag = '';
				let otherTags = [];

				if (tags.length > 0) {
					const activeTag = checkProductStatus(headerDropDown);

					if (productStatusList.includes(headerDropDown) && tags.includes(activeTag)) {
						firstTag = activeTag;
						otherTags = tags.filter((tag) => tag !== activeTag);
					} else {
						firstTag = tags[0];
						otherTags = tags.slice(1);
					}
				}
				return (
					<p className="">
						{data?.code}
						{data?.tags.length > 0 && (
							<span
								style={{
									backgroundColor: colorFormatTag(firstTag),
									color: firstTag === 'inactive' ? '#fff' : '#000',
									borderRadius: '20px',
									padding: '2px 10px',
									paddingBottom: '3px',
									marginLeft: '10px',
									fontSize: '11px',
								}}
							>
								{formatTag(firstTag)}
							</span>
						)}
						{otherTags.length > 0 && <TagHover tags={otherTags} />}
						{data?.status === 2 && (
							<span
								style={{
									backgroundColor: '#718096',
									color: 'white',
									borderRadius: '20px',
									padding: '2px 10px',
									paddingBottom: '3px',
									marginLeft: '10px',
									fontSize: '11px',
								}}
							>
								Draft
							</span>
						)}
					</p>
				);
			},
			headerComponent: () => (
				<div
					className="header-clickable"
					onClick={() => sortProduct({ sortBy: 'asc', orderBy: 'product_code' })}
				>
					<div className="header-inner-55">
						<p className="table-header__label_invoices mb-0">
							CODE
							<span className="sort-icon">{sortIconMap[sortDirection?.product_code]}</span>
						</p>
					</div>
				</div>
			),
		},

		{
			field: 'PRODUCT NAME',
			headerClass: 'HeaderBg',
			suppressSizeToFit: true,
			minWidth: 200,
			flex: 1,
			headerComponent: () => (
				<div
					className="header-clickable"
					onClick={() => sortProduct({ sortBy: 'asc', orderBy: 'product_name' })}
				>
					<div className="header-inner-55">
						<p className="table-header__label_invoices mb-0">
							PRODUCT NAME
							<span className="sort-icon">{sortIconMap[sortDirection?.product_name]}</span>
						</p>
					</div>
				</div>
			),
		},
		{
			field: 'STOCK IN HAND',
			headerClass: 'HeaderBg  right-align',
			suppressSizeToFit: true,
			minWidth: 70,
			maxWidth: 200,
			flex: 1,
			cellClass: 'right-align',
			headerComponent: () => (
				<div
					className="header-clickable header-right w-100"
					onClick={() => sortProduct({ sortBy: 'asc', orderBy: 'stock_in_hand' })}
				>
					<p className="d-flex align-items-center justify-content-end text-dark  table-header__label_invoices mb-0">
						STOCK
						<span className="sort-icon">{sortIconMap[sortDirection?.stock_in_hand]}</span>
					</p>
				</div>
			),
		},

		{
			field: 'REORDER LEVEL',
			headerClass: 'HeaderBg',
			suppressSizeToFit: true,
			minWidth: 100,
			maxWidth: 150,
			flex: 1,
			headerComponent: () => {
				return (
					<div
						className="header-clickable"
						onClick={() => sortProduct({ sortBy: 'asc', orderBy: 'reorder_level' })}
					>
						<div className="header-inner-55">
							<p className="table-header__label_invoices mb-0">
								<p className="d-none d-lg-block mb-0">REORDER LEVEL</p>
								<p className="d-block d-lg-none mb-0">REORDER</p>
								<span className="sort-icon">{sortIconMap[sortDirection?.reorder_level]}</span>
							</p>
						</div>
					</div>
				);
			},
		},
		...(params.filters.sales_product || params.filters.purchase_product
			? [
				{
					field: 'AMOUNT',
					headerClass: 'HeaderBg',
					suppressSizeToFit: true,
					minWidth: 150,
					flex: 1,
					headerComponent: () => {
						return (
							<div
								style={{
									width: '100%',
									paddingTop: '10px',
									cursor: 'pointer',
								}}
								onClick={() => sortProduct({ sortBy: 'asc', orderBy: 'amount' })}
							>
								<div
									style={{
										width: '55px',
									}}
								>
									<p
										style={{
											display: 'flex',
											alignItems: 'center',
											color: 'black',
										}}
									>
										AMOUNT
										<span
											style={{
												fontSize: '18px',
												fontWeight: '800',
											}}
										>
											{sortIconMap[sortDirection?.amount]}
										</span>
									</p>
								</div>
							</div>
						);
					},
				},
			]
			: []),
	];

	async function handleOnFocusSelectedFilterInput(key) {
		let selectInputData = [];
		if (key !== 'status') {
			const data = await getProductList({ filterBy: key, pageSize: 10000, page: 1 });

			selectInputData = data?.productWithStockCount?.map((po) => ({
				key: po[key],
				value: po[key],
			}));
		} else {
			selectInputData = [
				{ key: 'active_products', value: 'Active Products' },
				{ key: 'inactive_products', value: 'Inactive Products' },
				{ key: 'draft_products', value: 'Draft Products' },
				{ key: 'low_stock_products', value: 'Low Stock Products' },
				{ key: 'out_of_stocks', value: 'Out Of Stocks' },
				{ key: 'excess_stocks', value: 'Excess Stocks' },
				{ key: 'near_expiry_stocks', value: 'Near Expiry Stocks' },
				{ key: 'expired_stocks', value: 'Expired Stocks' },
				// { key: 'sales_product', value: 'Sales' },
				// { key: 'purchase_product', value: 'Purchase' },
			];
		}
		dispatch(setSelectedInputData({ key, data: selectInputData }));
	}

	async function searchSelectedInputItems(key, value) {
		try {
			let optionsList;
			if (key === 'status') {
				optionsList = [
					{ key: 'active_products', value: 'Active Products' },
					{ key: 'inactive_products', value: 'Inactive Products' },
					{ key: 'draft_products', value: 'Draft Products' },
					{ key: 'low_stock_products', value: 'Low Stocks Products' },
					{ key: 'out_of_stocks', value: 'Out Of Stocks' },
					{ key: 'excess_stocks', value: 'Excess Stocks' },
					{ key: 'near_expiry_stocks', value: 'Near Expiry Stocks' },
					{ key: 'expired_stocks', value: 'Expired Stocks' },
				];
			} else {
				const data = await getProductList({
					filterBy: key,
					filterValue: value,
					pageSize: 10000,
					page: 1,
				});
				optionsList = data?.productWithStockCount?.map((po) => ({
					key: po[key],
					value: po[key],
				}));
			}

			dispatch(setSelectedInputData({ key, data: optionsList }));
		} catch (error) {
			toast.error(error?.message || 'Something went wrong!');
		}
	}

	async function handleApplyFilters(params) {
		try {
			if (Object.keys(params).length === 0) return;
			if (params.status) {
				setHeaderDropDown(params.status);
				const statusMap = {
					'Inactive Products': 0,
					'Active Products': 1,
					'Draft Products': 2,
				};
				if (params.status === 'Expired Stocks') {
					params['expired_stocks'] = true;
					delete params.status;
				} else if (params.status === 'Excess Stocks') {
					params['excess_stocks'] = true;
					delete params.status;
				} else if (params.status === 'Near Expiry Stocks') {
					params['near_expiry_stocks'] = true;
					delete params.status;
				} else if (params.status === 'Out Of Stocks') {
					params['out_of_stocks'] = true;
					delete params.status;
				} else if (params.status === 'Low Stock Products') {
					params['low_stock_products'] = true;
					delete params.status;
				} else if (params.status === 'Sales') {
					params['sales_product'] = true;
					delete params.status;
				} else if (params.status === 'Purchase') {
					params['purchase_product'] = true;
					delete params.status;
				} else {
					params.status = statusMap[params.status];
				}
			}
			const { products, totalPages } = await getProducts({
				filters: params,
				orderBy: advanceFilterOrderby,
				sortBy: advanceFilterSortBy,
				page: advanceFilterPage,
				pageSize: advanceFilterPageSize,
			});
			dispatch(setAdvanceFilterTotalPage({ totalPages }));

			setIsAdvanceFilterOpen(false);
			setTotalPages(totalPages);
			if (products.length > 0) {
				setTableData(mappedTableData(products));
			} else {
				setTableData([]);
			}
		} catch (error) {
			toast.error(error?.message || 'Something went wrong! Try again.');
		}
	}

	function mappedTableData(data) {
		return (
			data?.map((ele) => {
				return {
					id: ele.product_id,
					'PRODUCT NAME': ele?.product_name,
					product_code: JSON.stringify({
						code: ele?.product_code,
						status: ele?.status,
						tags: ele?.tags,
					}),
					'STOCK IN HAND': ele?.stock_in_hand || 0,
					'REORDER LEVEL': 'NA',
					Status: 'Enable',
					IMAGE: ele?.image,
					...(params.filters.sales_product || params.filters.purchase_product
						? { AMOUNT: Number(ele?.amount).toFixed(2) }
						: {}),
				};
			}) ?? []
		);
	}

	const getAllProduct = async () => {
		try {
			setLoader(true);
			const { products, totalPages } = await getProducts(params);
			const mappedData = mappedTableData(products);
			setTableData(mappedData);
			setProductList(products);
			setTotalPages(totalPages);
		} catch (error) {
		} finally {
			setLoader(false);
		}
	};

	const handlePageChange = (page) => {
		if (isAdvanceFilterApplied) {
			dispatch(setAdvanceFilterPage({ page: page }));
		} else {
			setParams((prev) => ({
				...prev,
				page: page,
			}));
			setCurrentPage(page);
		}
	};

	const filterProduct = (param, value, dropDownData) => {
		if (dropDownData === 'Sales' || dropDownData === 'Purchase') {
			dispatch(clearAdvanceFilter());
			setParams((prev) => ({
				...prev,
				...param,
			}));
			setStateCondition(value);
			setHeaderDropDown(dropDownData);
			setCurrentPage(1);
		} else {
			setParams((prev) => ({
				...prev,
				filters: {},
			}));
			if (dropDownData === 'All Products') {
				dispatch(clearAdvanceFilter());

				setHeaderDropDown('All Products');
				return;
			}
			setHeaderDropDown(dropDownData);
			const updatedSelectedInput = selectedInputs.map((input) => {
				if (input.key === 'status') {
					return {
						...input,
						value: dropDownData,
					};
				}
				return input;
			});
			dispatch(setSelectedInput({ key: 'status', label: 'Status' }));
			dispatch(setSelectedInputValue({ key: 'status', value: dropDownData }));
			dispatch(setAdvanceFilter({ isAdvanceFilterApplied: true }));
			var selectInputData = [
				{ key: 'active_products', value: 'Active Products' },
				{ key: 'inactive_products', value: 'Inactive Products' },
				{ key: 'draft_products', value: 'Draft Products' },
				{ key: 'low_stock_products', value: 'Low Stock Products' },
				{ key: 'out_of_stocks', value: 'Out Of Stocks' },
				{ key: 'excess_stocks', value: 'Excess Stocks' },
				{ key: 'near_expiry_stocks', value: 'Near Expiry Stocks' },
				{ key: 'expired_stocks', value: 'Expired Stocks' },
			];
			dispatch(setSelectedInputData({ key: 'status', data: selectInputData }));
			const params = getFiltersParams(updatedSelectedInput);
			handleApplyFilters(params);
		}
	};

	const sortProduct = async (param) => {
		const newDirection = sortDirection[param.orderBy] === 'desc' ? 'asc' : 'desc';
		setSortDirection({ [param.orderBy]: newDirection });
		if (isAdvanceFilterApplied) {
			dispatch(setAdvanceFilter({ orderBy: param.orderBy, sortBy: newDirection }));
			const params = getFiltersParams(selectedInputs);
			handleApplyFilters(params);
		} else {
			setParams((prev) => ({
				...prev,
				orderBy: param.orderBy,
				sortBy: newDirection,
			}));
		}
	};

	const markAsActive = () => {
		let formbody = {
			product_ids: bulkAction,
			status: 1,
		};
		change_status(formbody).then((res) => {
			if (res?.success) {
				toast.success(res?.message);
				getAllProduct();
				setBulkAction([]);
			} else {
				toast.error(res?.message);
			}
		});
	};

	const markAsInactive = () => {
		let formbody = {
			product_ids: bulkAction,
			status: 0,
		};
		change_status(formbody).then((res) => {
			if (res?.success) {
				toast.success(res?.message);
				getAllProduct();
				setBulkAction([]);
			} else {
				toast.error(res?.message);
			}
		});
	};

	const handlegroupUpdate = () => {
		let body = {
			name: groupName,
			status: Number(groupStatus),
		};
		dispatch(group_update(GroupID, body)).then((res) => {
			if (res?.success) {
				toast.success(res?.message);
			} else {
				toast.error(res?.message);
				let err = formatErrors(res?.data?.message);
				setError(err);
			}
		});
	};

	const exportData = (param) => {
		ExportTable(param);
	};

	const onRowClick = (id) => {
		if (id && hasPermission('inventory.products.view', user?.role?.role_permissions)) {
			const data = tableData.find((item) => Number(item.id) === Number(id));
			const code = JSON.parse(data['product_code']);
			if (code.status === 2) {
				navigate(`/user/${suburl}/product-create/id=${id}&status=draft`);
			} else {
				navigate(`/user/${suburl}/product-create/${id}`);
			}
		}
	};

	useEffect(() => {
		if (productgroupData) {
			const result = ObjectCreate({
				data: productgroupData,
				key: 'product_group_id',
				value: 'name',
			});
			const groupName = productgroupData?.filter((ele) => {
				return ele?.product_group_id === Number(productId);
			});
			setgroupName(groupName?.[0]?.name);
			setgroupStatus(`${groupName?.[0]?.status}`);
			setGroupOptions(result);
		}
	}, [productgroupData]);

	const groupList = () => {
		let param = `page=${1}&pageSize=200`;
		product_group_list(param);
	};

	const setFilterFromUrl = () => {
		if (searchParams.get('out_of_stocks')) {
			filterProduct({ filters: { out_of_stocks: true } }, '', 'Out Of Stocks');
		}
		if (searchParams.get('low_stock_products')) {
			filterProduct({ filters: { low_stock: true } }, '', 'Low Stock Products');
		}
		if (searchParams.get('excess_stocks')) {
			filterProduct({ filters: { excess_stocks: true } }, '', 'Excess Stocks');
		}
		if (searchParams.get('near_expiry_stocks')) {
			filterProduct({ filters: { near_expiry_stocks: true } }, '', 'Near Expiry Stocks');
		}
		if (searchParams.get('expired_stocks')) {
			filterProduct({ filters: { expired_stocks: true } }, '', 'Expired Stocks');
		}
	};

	useEffect(() => {
		groupList();
	}, []);

	useEffect(() => {
		if (searchParams && isNaN(searchParams)) {
			setFilterFromUrl();
		}
	}, [searchParams]);

	useEffect(() => {
		if (isAdvanceFilterApplied) {
			const params = getFiltersParams(selectedInputs);
			handleApplyFilters(params);
		} else {
			if (searchParams.size === 0) {
				getAllProduct();
			}
		}
	}, [
		productId,
		sortParam,
		currentPage,
		advanceFilterPage,
		isAdvanceFilterApplied,
		advanceFilterPageSize,
		params,
	]);

	return (
		<div>
			{bulkAction && bulkAction.length > 0 ? (
				<div className="product-pg-header">
					<div className="dropdown text-end">
						<p className="d-block link-dark text-decoration-none">Bulk Actions</p>
					</div>
					<div className="add-product-button">
						{stateCondition !== 'active' && (
							<Button
								type="button"
								button="Mark as Active"
								className="mt-0 px-4 btn-gray"
								onClick={markAsActive}
							/>
						)}
						{stateCondition !== 'inactive' && (
							<Button
								type="button"
								button="Mark as Inactive"
								className="mt-0 px-4 btn-gray"
								onClick={markAsInactive}
							/>
						)}
						<div className="dropdown-container">
							<div
								className="select-box text-dark"
								style={{ backgroundColor: '#daddec' }}
								onClick={() => setShowOptions(!showOptions)}
							>
								<div className="d-flex flex-row align-items-center gap-4">
									<div className="fs-5 font-bold">{'New Transaction'}</div>
									<img
										src={arrowDownBlackIcon}
										alt="arrow"
										width={10}
										height={10}
									/>
								</div>
							</div>

							{showOptions && (
								<ul
									className="options-list"
									style={{ zIndex: 40, width: '145px' }}
								>
									{['Purchase Order', 'Sales Invoice'].map((label, idx) => (
										<li
											key={idx}
											onClick={() => {
												if (label === 'Purchase Order') {
													const data = productList
														?.filter((item) => bulkAction.includes(item.product_id))
														.map((item) => {
															return {
																id: item.product_id,
																packaging: item.packaging_name,
															};
														});
													navigate(`/user/${suburl}/purchases-order-create`, {
														state: { products: data },
													});
												} else if (label === 'Sales Invoice') {
													const data = productList
														?.filter((item) => bulkAction.includes(item.product_id))
														.map((item) => {
															return {
																id: item.product_id,
																tax1: item.tax_1,
																tax2: item.tax_2,
															};
														});
													navigate(`/user/${suburl}/invoices-create`, {
														state: { products: data },
													});
												}
											}}
										>
											<div className="text-dark">{label}</div>
										</li>
									))}
								</ul>
							)}
						</div>
						<Button
							type="button"
							button=""
							className="mt-0 px-4 btn-danger"
							close
							onClick={() => {
								setBulkAction(false);
								setBulkAction([]);
								deselectRows && deselectRows();
							}}
						/>
					</div>
				</div>
			) : (
				<div className="product-pg-header">
					{productId ? (
						<div className="dropdown text-end">
							<a className="d-block link-dark text-decoration-none">
								<p>Group Details</p>
							</a>
						</div>
					) : (
						<div
							className="dropdown text-end d-flex"
							style={{ gap: '12px', alignItems: 'center', display: 'flex' }}
						>
							<a
								className="d-block link-dark text-decoration-none dropdown-toggle"
								id="dropdownUser1"
								data-bs-toggle="dropdown"
								aria-expanded="false"
							>
								<p>{headerDropDown}</p>
							</a>
							<ul
								className="dropdown-menu font-14"
								aria-labelledby="dropdownUser1"
								style={{ minWidth: '240px' }}
							>
								<li>
									<a
										className="dropdown-item"
										onClick={() => filterProduct({ filters: {} }, '', 'All Products')}
									>
										All Products
									</a>
								</li>
								<li>
									<a
										className="dropdown-item"
										onClick={() =>
											filterProduct({ filters: { status: 1 } }, 'active', 'Active Products')
										}
									>
										Active Products
									</a>
								</li>

								<li>
									<a
										className="dropdown-item"
										onClick={() =>
											filterProduct({ filters: { status: 0 } }, 'inactive', 'Inactive Products')
										}
									>
										Inactive Products
									</a>
								</li>
								<li>
									<a
										className="dropdown-item"
										onClick={() =>
											filterProduct({ filters: { status: 2 } }, 'draft', 'Draft Products')
										}
									>
										Draft Products
									</a>
								</li>

								<li>
									<a
										className="dropdown-item"
										onClick={() =>
											filterProduct({ filters: { low_stock: true } }, '', 'Low Stock Products')
										}
									>
										Low Stock Products
									</a>
								</li>
								<li>
									<a
										className="dropdown-item"
										onClick={() =>
											filterProduct({ filters: { out_of_stocks: true } }, '', 'Out Of Stocks')
										}
									>
										Out Of Stocks
									</a>
								</li>
								<li>
									<a
										className="dropdown-item"
										onClick={() =>
											filterProduct({ filters: { excess_stocks: true } }, '', 'Excess Stocks')
										}
									>
										Excess Stocks
									</a>
								</li>
								<li>
									<a
										className="dropdown-item"
										onClick={() =>
											filterProduct(
												{ filters: { near_expiry_stocks: true } },
												'',
												'Near Expiry Stocks',
											)
										}
									>
										Near Expiry Stocks
									</a>
								</li>
								<li>
									<a
										className="dropdown-item"
										onClick={() =>
											filterProduct({ filters: { expired_stocks: true } }, '', 'Expired Stocks')
										}
									>
										Expired Stocks
									</a>
								</li>

								<li>
									<a
										className="dropdown-item"
										onClick={() => filterProduct({ filters: { sales_product: true } }, '', 'Sales')}
									>
										Sales
									</a>
								</li>
								<li>
									<a
										className="dropdown-item"
										onClick={() =>
											filterProduct({ filters: { purchase_product: true } }, '', 'Purchase')
										}
									>
										Purchase
									</a>
								</li>
							</ul>
							<div>
								{isAdvanceFilterApplied ? (
									<div>
										<button
											onClick={() => {
												dispatch(clearAdvanceFilter());
												setHeaderDropDown('All Products');
												navigate(`/user/${suburl}/product`);
											}}
											style={{
												background: 'transparent',
												color: '#FF0000',
												fontSize: '14px',
												cursor: 'pointer',
												fontWeight: '600',
												lineHeight: '24px',
											}}
										>
											<img
												src={clearAllFilter}
												alt=""
												style={{ width: '18px', height: '18px', marginRight: '8px' }}
											/>
											Clear All Filters
										</button>
									</div>
								) : (
									<div className="d-flex gap-4">
										<Button
											type="button"
											button="Advanced Filters"
											className="mt-0 px-4 btn-primary"
											onClick={() => setIsAdvanceFilterOpen(true)}
											icon={advanceFilterIcon}
										/>
										<Button
											type="button"
											button="Master Products"
											className="mt-0 px-4 btn-primary"
											onClick={() => setIsProductMasterOpen(true)}
										/>
									</div>
								)}
							</div>
						</div>
					)}
					<div className="d-flex align-items-center">
						{productId ? (
							<div className="add-product-button">
								<Button
									type="button"
									className="btn-primary mt-0 px-4"
									button="Save"
									disabled={
										!hasPermission('inventory.products.create', user?.role?.role_permissions)
									}
									onClick={handlegroupUpdate}
								/>
								<Button
									type="button"
									className="mt-0 btn-danger add-pro"
									button=""
									close
									onClick={() => navigateRouter(-1)}
								/>
							</div>
						) : (
							<Button
								type="button"
								button="Add New"
								disabled={!hasPermission('inventory.products.create', user?.role?.role_permissions)}
								className="mt-0 px-4 btn-primary"
								onClick={() => navigateRouter(`/user/${suburl}/product-create`)}
								add
							/>
						)}
						{!productId && (
							<div className="dropdown text-end ms-3">
								<a
									className="d-block link-dark text-decoration-none"
									id="dropdownUser1"
									data-bs-toggle="dropdown"
									aria-expanded="false"
								>
									<img src={sortbydot} />
								</a>
								<ul
									className="dropdown-menu font-14"
									aria-labelledby="dropdownUser1"
									style={{ minWidth: '240px' }}
								>
									<li>
										<a className="dropdown-item sortBy">Sort by</a>
									</li>
									<li>
										<a
											style={{
												display: 'flex',
												alignItems: 'center',
												justifyContent: 'space-between',
											}}
											className="dropdown-item"
											onClick={() => sortProduct({ sortBy: 'asc', orderBy: 'created_at' })}
										>
											Created Time
											<span>{sortIconMap[sortDirection?.created_at]}</span>
										</a>
									</li>
									<li>
										<a
											style={{
												display: 'flex',
												alignItems: 'center',
												justifyContent: 'space-between',
											}}
											className="dropdown-item"
											onClick={() => sortProduct({ sortBy: 'asc', orderBy: 'product_name' })}
										>
											Name
											<span>{sortIconMap[sortDirection?.product_name]}</span>
										</a>
									</li>
									<li>
										<a
											style={{
												display: 'flex',
												alignItems: 'center',
												justifyContent: 'space-between',
											}}
											className="dropdown-item"
											onClick={() => sortProduct({ sortBy: 'asc', orderBy: 'product_code' })}
										>
											Product Code
											<span>{sortIconMap[sortDirection?.product_code]}</span>
										</a>
									</li>
									<li>
										<a
											style={{
												display: 'flex',
												alignItems: 'center',
												justifyContent: 'space-between',
											}}
											className="dropdown-item"
											onClick={() => sortProduct({ sortBy: 'asc', orderBy: 'stock_in_hand' })}
										>
											Stock on Hand
											<span>{sortIconMap[sortDirection?.stock_in_hand]}</span>
										</a>
									</li>
									<li>
										<a
											style={{
												display: 'flex',
												alignItems: 'center',
												justifyContent: 'space-between',
											}}
											className="dropdown-item"
											onClick={() => sortProduct({ sortBy: 'asc', orderBy: 'updated_at' })}
										>
											Last Modified Time
											<span>{sortIconMap[sortDirection?.updated_at]}</span>
										</a>
									</li>
									<hr />
									<li>
										<a
											className={`dropdown-item ${!hasPermission('inventory.products.import', user?.role?.role_permissions) ? 'disabled' : ''}`}
											onClick={() => setIsbuklImport(true)}
										>
											Import Product
										</a>
									</li>
									<li>
										<a
											className={`dropdown-item ${!hasPermission('inventory.products.export', user?.role?.role_permissions) ? 'disabled' : ''}`}
											onClick={() => exportData(`product`)}
										>
											Export Product
										</a>
									</li>
									<hr />
									<li>
										<a className="dropdown-item">Prefrence</a>
									</li>
									<li>
										<a
											className="dropdown-item"
											onClick={() => {
												dispatch(clearAdvanceFilter());
												setHeaderDropDown('All Products');
												setParams({
													page: 1,
													pageSize: 20,
													filters: {},
													sortBy: 'desc',
													orderBy: 'created_at',
												});
											}}
										>
											Refresh
										</a>
									</li>
								</ul>
							</div>
						)}
					</div>
				</div>
			)}

			<div className="active-filter-wrapper">
				{isAdvanceFilterApplied && (
					<div className="active-filter-list">
						{selectedInputs.map((item) => (
							<AdvanceFilterSelectInput
								key={item.key}
								options={item?.data}
								placeholder={`Select ${item?.label}`}
								value={item?.value}
								disabled={false}
								onFocusCb={() => {
									if (item.value === '') {
										handleOnFocusSelectedFilterInput(item?.key);
									}
								}}
								onChange={(value) => { }}
								onSelect={(option) => {
									// if (item?.key === 'status') {
									// 	setHeaderDropDown(option?.value);
									// }
									const updatedSelectedInput = selectedInputs.map((input) => {
										if (input.key === item?.key) {
											return {
												...input,
												value: option?.value,
											};
										}
										return input;
									});
									const params = getFiltersParams(updatedSelectedInput);
									handleApplyFilters(params);
									dispatch(setSelectedInputValue({ key: item?.key, value: option.value }));
								}}
								removeInput={() => {
									dispatch(removeSelectedInput({ key: item?.key }));
									if (item.key === 'status') {
										setHeaderDropDown('All Products');
										navigate(`/user/${suburl}/product`);
									}
									const params = getFiltersParams(
										selectedInputs.filter((input) => input.key !== item?.key),
									);
									handleApplyFilters(params);
								}}
								className="selectInput"
							/>
						))}
						<div className="add-filter-btn-wrapper">
							<button
								type="button"
								className="add-filter-btn"
								onClick={() => setIsAdvanceFilterOpen(true)}
							>
								<span className="add-filter-btn__icon"><Plus width={15} /></span>
								Add Filter
							</button>
						</div>
					</div>
				)}
			</div>

			{productId && bulkAction?.length === 0 && (
				<div className="add-group-detail px-4 mx-2 py-3 my-2">
					<div className="row">
						<div className="col-5">
							<InputField
								label="Group Name"
								placeholder="Enter Group Name"
								type="text"
								onChange={(val) => setgroupName(val)}
								value={groupName}
								error={error?.name}
							/>
						</div>
						<div class="col-3">
							<InputSelect
								label="Status"
								placeholder="Status"
								onChange={(value) => setgroupStatus(value)}
								value={groupStatus}
								options={status_dropdown || []}
								error={error?.status}
							/>
						</div>
					</div>
				</div>
			)}
			{loading ? (
				<div
					className="d-flex justify-content-center align-items-center"
					style={{ height: '100%', marginTop: '20%' }}
				>
					<span
						className="Page_loader"
						role="status"
						aria-hidden="true"
					></span>
				</div>
			) : tableData.length > 0 ? (
				<div className="productTable-body">
					<Table
						row={tableData}
						className="productTable"
						coloum={ProductTableColumn}
						bulkAction={bulkAction}
						onRowClick={onRowClick}
						style={isAdvanceFilterApplied ? { height: 'calc(100vh - 185px)' } : {}}
						action={setBulkAction}
						onDeselectAll={handleDeselectAll}
					/>
				</div>
			) : (
				<DataNotFound
					title={'Build your perfect product list!'}
					subtitle={'Simplify product tracking and updates.'}
					descriptionTitle={'Stay organized!'}
					descriptionSubTitle={' Maintain all your product details in one place for smooth'}
					descriptionContent={'inventory and billing management.'}
					buttonText={'Add New Product'}
					disabled={!hasPermission('inventory.products.create', user?.role?.role_permissions)}
					onClick={() => navigateRouter(`/user/${suburl}/product-create`)}
				/>
			)}
			{tableData.length > 0 && (
				<Pagination
					currentPage={isAdvanceFilterApplied ? advanceFilterPage : params.page}
					totalPages={isAdvanceFilterApplied ? advanceFilterTotalPages : totalPages}
					onChangePage={handlePageChange}
					pageSize={isAdvanceFilterApplied ? advanceFilterPageSize : params.pageSize}
					setParam={(value) => {
						if (isAdvanceFilterApplied) {
							dispatch(setAdvanceFilterPage({ page: 1, pageSize: value }));
						} else {
							setParams((prev) => ({
								...prev,
								pageSize: value,
								page: 1,
							}));
						}
					}}
				/>
			)}
			{open && (
				<div>
					<Modal
						className="add-productgroup-modal"
						isOpen={open}
						onClose={() => setIsOpen(false)}
						title="Add to Group"
					>
						<AddToGroupModal
							isOpen={open}
							onCLose={() => setIsOpen(false)}
							reloadTable={getAllProduct}
							groupOption={groupOption}
							action={bulkAction}
						/>
					</Modal>
				</div>
			)}

			{buklImport && (
				<div>
					<Modal
						className="add-productgroup-modal"
						isOpen={buklImport}
						onClose={() => setIsbuklImport(false)}
						title=" Product bulk Import "
					>
						<BulkImport
							isOpen={buklImport}
							onClose={() => setIsbuklImport(false)}
							reloadTable={getAllProduct}
							type={'product'}
						/>
					</Modal>
				</div>
			)}
			{isAdvanceFilterOpen && (
				<AdvanceFilter
					modalLabel="Note: You can create a bill for either Yet to Receive Items or Received Items."
					isOpen={isAdvanceFilterOpen}
					advanceFilterOptions={advanceFilterOptions?.product}
					onFocusSelectedFilterInput={handleOnFocusSelectedFilterInput}
					handleOnChangeSelectedFilterInput={(key, value) => searchSelectedInputItems(key, value)}
					onClose={() => {
						setIsAdvanceFilterOpen(false);
					}}
					onApply={handleApplyFilters}
				/>
			)}
			{isProductMasterOpen && (
				<ProductMasterModel
					isProductMasterOpen={isProductMasterOpen}
					setIsProductMasterOpen={setIsProductMasterOpen}
				/>
			)}
		</div>
	);
};

export default Product;
